/**
 * The product's name, in exactly one place.
 *
 * Everything user-facing — the app header, page titles, the marketing site,
 * provider attribution headers, email copy — reads from here, so renaming
 * the product is an edit to this file and nothing else. The marketing app
 * imports this same constant; do not fork a copy there. (The one exception
 * is apps/web/index.html's static <title>, which cannot import — keep it in
 * step by hand.)
 *
 * "Relay": a meeting comes in, and what leaves is the version worth passing
 * on — transcribed, translated, cut down, handed to the next person.
 */
export const BRAND = {
  name: "Relay",
  /** One line under the wordmark, and the marketing hero's opener. */
  tagline: "Every meeting, worth replaying.",
  /** Where the product lives; marketing links point at the app here. */
  appUrl: "https://app.rec.aimamin.com",
  marketingUrl: "https://rec.aimamin.com",
} as const;
